import React, { useEffect } from 'react'
import { Alert, Button, Flex, Skeleton, Typography } from 'antd'
import { useUnit } from 'effector-react'
import { useParams } from 'react-router-dom'
import {
  $wallet,
  $walletHasError,
  getWalletFx,
  walletRequested,
} from '../details/model'
import { EditWalletForm } from './EditWalletForm'

export const WalletGuardWalletEditPage = () => {
  const { walletID } = useParams()
  const { wallet, loading, hasError, requestWallet } = useUnit({
    wallet: $wallet,
    loading: getWalletFx.pending,
    hasError: $walletHasError,
    requestWallet: walletRequested,
  })

  const walletId = Number(walletID)
  const hasValidId = Number.isSafeInteger(walletId) && walletId > 0

  useEffect(() => {
    if (hasValidId) requestWallet(walletId)
  }, [requestWallet, walletId, hasValidId])

  const renderContent = () => {
    if (!hasValidId) {
      return (
        <Alert
          type="error"
          showIcon
          message="Некорректный идентификатор кошелька"
        />
      )
    }

    if (hasError) {
      return (
        <Alert
          type="error"
          showIcon
          message="Не удалось загрузить кошелёк"
          action={
            <Button onClick={() => requestWallet(walletId)}>Повторить</Button>
          }
        />
      )
    }

    if (loading || wallet === null) return <Skeleton active />

    return <EditWalletForm wallet={wallet} />
  }

  return (
    <Flex vertical gap={24}>
      <Typography.Title level={1} style={{ margin: 0 }}>
        Редактирование кошелька
      </Typography.Title>

      {renderContent()}
    </Flex>
  )
}
